"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fuehrungsrinne = exports.BefestigungInnenCProfil = exports.ZusBreiteFRBefestigung = void 0;
const echain_math_1 = require("@igus/echain-math");
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const Article_1 = require("../Article");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const Kette_1 = require("../kette/Kette");
const echain_product_models_1 = require("@igus/echain-product-models");
class ZusBreiteFRBefestigung {
    constructor(model) {
        this.model = model;
    }
    get montageSetId() {
        return this.model.MontageSetId;
    }
    set montageSetId(value) {
        this.model.MontageSetId = value;
    }
    get breite() {
        return (0, echain_shared_quantities_1.Q)(this.model.Breite);
    }
    set breite(value) {
        this.model.Breite = value.quantity;
    }
}
exports.ZusBreiteFRBefestigung = ZusBreiteFRBefestigung;
class BefestigungInnenCProfil {
    constructor(model) {
        this.model = model;
    }
    get kettenSerieId() {
        return this.model.KettenSerieId;
    }
    set kettenSerieId(value) {
        this.model.KettenSerieId = value;
    }
    get minBRi() {
        return (0, echain_shared_quantities_1.Q)(this.model.MinBRi);
    }
    set minBRi(value) {
        this.model.MinBRi = value.quantity;
    }
}
exports.BefestigungInnenCProfil = BefestigungInnenCProfil;
/**
 * The class `Fuehrungsrinne` is a Value Object representing an igus Fuehrungsrinne article.
 */
class Fuehrungsrinne extends Article_1.Article {
    constructor() {
        super(...arguments);
        this.className = 'Fuehrungsrinne';
    }
    get bestTyp() {
        return this.model.BestTyp;
    }
    set bestTyp(v) {
        this.model.BestTyp = v;
    }
    get gewicht() {
        return echain_shared_quantities_1.Q.optional(this.model.Gewicht);
    }
    set gewicht(v) {
        this.model.Gewicht = v === null || v === void 0 ? void 0 : v.quantity;
    }
    get laenge() {
        return echain_shared_quantities_1.Q.optional(this.model.Laenge);
    }
    set laenge(v) {
        this.model.Laenge = v === null || v === void 0 ? void 0 : v.quantity;
    }
    get opti() {
        return this.model.Opti;
    }
    set opti(v) {
        this.model.Opti = v;
    }
    get typ() {
        return this.model.Typ;
    }
    set typ(v) {
        this.model.Typ = v;
    }
    get zusBreiteFRBefestigungInnen() {
        return this.model.ZusBreiteFRBefestigungInnen.map((v) => new ZusBreiteFRBefestigung(v));
    }
    set zusBreiteFRBefestigungInnen(values) {
        this.model.ZusBreiteFRBefestigungInnen = values.map((v) => v.model);
    }
    get zusBreiteFRBefestigungAussen() {
        return this.model.ZusBreiteFRBefestigungAussen.map((v) => new ZusBreiteFRBefestigung(v));
    }
    set zusBreiteFRBefestigungAussen(values) {
        this.model.ZusBreiteFRBefestigungAussen = values.map((v) => v.model);
    }
    get zusBreiteAussenOhneMontageset() {
        return echain_shared_quantities_1.Q.optional(this.model.ZusBreiteAussenOhneMontageset);
    }
    set zusBreiteAussenOhneMontageset(v) {
        this.model.ZusBreiteAussenOhneMontageset = v === null || v === void 0 ? void 0 : v.quantity;
    }
    get zusBreiteBRi() {
        return echain_shared_quantities_1.Q.optional(this.model.ZusBreiteBRi);
    }
    set zusBreiteBRi(v) {
        this.model.ZusBreiteBRi = v === null || v === void 0 ? void 0 : v.quantity;
    }
    get auflageHoehe() {
        return echain_shared_quantities_1.Q.optional(this.model.AuflageHoehe);
    }
    set auflageHoehe(v) {
        this.model.AuflageHoehe = v === null || v === void 0 ? void 0 : v.quantity;
    }
    get befestigungInnenCProfil() {
        return this.model.BefestigungInnenCProfil.map((v) => new BefestigungInnenCProfil(v));
    }
    set befestigungInnenCProfil(values) {
        this.model.BefestigungInnenCProfil = values.map((v) => v.model);
    }
    get isSet() {
        return this.model.IsSet;
    }
    set isSet(v) {
        this.model.IsSet = v;
    }
    get isSLH() {
        return this.model.IsSLH;
    }
    set isSLH(v) {
        this.model.IsSLH = v;
    }
    static fromScratch() {
        return new Fuehrungsrinne({
            ArticleType: echain_product_models_1.ArticleType.fuehrungsrinne,
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
            ZusBreiteFRBefestigungInnen: [],
            ZusBreiteFRBefestigungAussen: [],
            BefestigungInnenCProfil: [],
        });
    }
    static fromExistingArtNr(args, cloneStrategy = 'deep') {
        const msg = 'Fuehrungsrinne.fromExistingArtNr: ';
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(args.Id, msg + 'Id: '),
            echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: '),
        ]);
        const fuehrungsrinne = Fuehrungsrinne.fromJson(args, cloneStrategy);
        fuehrungsrinne.artNrExists = true;
        return fuehrungsrinne;
    }
    static fromInventedArtNr(args, cloneStrategy = 'deep') {
        const msg = 'Fuehrungsrinne.fromInventedArtNr: ';
        echain_shared_validation_1.Validation.throws([echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: ')]);
        const fuehrungsrinne = Fuehrungsrinne.fromJson(args, cloneStrategy);
        fuehrungsrinne.artNrExists = false;
        fuehrungsrinne.artNr = undefined;
        return fuehrungsrinne;
    }
    static fromJson(args, cloneStrategy = 'deep') {
        const fuehrungsrinne = Fuehrungsrinne.fromScratch();
        fuehrungsrinne.fromJson(args, cloneStrategy);
        return fuehrungsrinne;
    }
    static fromModel(model) {
        const fuehrungsrinne = Fuehrungsrinne.fromScratch();
        Object.assign(fuehrungsrinne.model, model);
        Object.assign(model, fuehrungsrinne.model);
        fuehrungsrinne.model = model;
        return fuehrungsrinne;
    }
    clone() {
        return this._clone(Fuehrungsrinne.fromScratch());
    }
    duplicate() {
        return this._duplicate();
    }
    static calculateStuecklaengeByOpti(opti) {
        if (!opti)
            return undefined;
        switch (opti) {
            case echain_shared_articles_1.FuehrungsrinneOpti.RINNE_2M:
            case echain_shared_articles_1.FuehrungsrinneOpti.RINNE_GLEITSCHIENE_2M:
            case echain_shared_articles_1.FuehrungsrinneOpti.FESTPUNKTMODUL_RINNE:
            case echain_shared_articles_1.FuehrungsrinneOpti.GLEITSCHIENE_2M:
            case echain_shared_articles_1.FuehrungsrinneOpti.ABLEGERINNE_EINZELND_2M:
            case echain_shared_articles_1.FuehrungsrinneOpti.ABLEGERINNE_WANDKONSOLE_2M:
            case echain_shared_articles_1.FuehrungsrinneOpti.RINNE_MIT_DAEMPFUNGSPROFIL_2M:
                return echain_shared_quantities_1.Length.mm(2000);
            case echain_shared_articles_1.FuehrungsrinneOpti.TWO_RINNE_2M:
            case echain_shared_articles_1.FuehrungsrinneOpti.TWO_RINNE_GLEITSCHIENE_2M:
            case echain_shared_articles_1.FuehrungsrinneOpti.TWO_GLEITSCHIENE_2M:
                return echain_shared_quantities_1.Length.mm(4000);
            case echain_shared_articles_1.FuehrungsrinneOpti.ABLEGERINNE_EINZELND_1M:
            case echain_shared_articles_1.FuehrungsrinneOpti.ABLEGERINNE_WANDKONSOLE_1M:
                return echain_shared_quantities_1.Length.mm(1000);
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(opti);
        }
    }
    calculateStuecklange() {
        return Fuehrungsrinne.calculateStuecklaengeByOpti(this.opti);
    }
    isLengthCalculationPossible() {
        return (this.isFuehrungsrinne() || this.isFuehrungsrinneGleitschiene()) && Boolean(this.typ);
    }
    isFuehrungsrinne() {
        return this.opti === echain_shared_articles_1.FuehrungsrinneOpti.RINNE_2M || this.opti === echain_shared_articles_1.FuehrungsrinneOpti.RINNE_MIT_DAEMPFUNGSPROFIL_2M;
    }
    isFuehrungsrinneGleitschiene() {
        return this.opti === echain_shared_articles_1.FuehrungsrinneOpti.RINNE_GLEITSCHIENE_2M;
    }
    isFestpunktmodulFuehrungsrinne() {
        return this.opti === echain_shared_articles_1.FuehrungsrinneOpti.FESTPUNKTMODUL_RINNE;
    }
    isFuehrungsrinneOhneMontageSet() {
        return Boolean(this.zusBreiteAussenOhneMontageset);
    }
    isAblegerinne() {
        return (this.opti === echain_shared_articles_1.FuehrungsrinneOpti.ABLEGERINNE_EINZELND_1M ||
            this.opti === echain_shared_articles_1.FuehrungsrinneOpti.ABLEGERINNE_EINZELND_2M ||
            this.opti === echain_shared_articles_1.FuehrungsrinneOpti.ABLEGERINNE_WANDKONSOLE_1M ||
            this.opti === echain_shared_articles_1.FuehrungsrinneOpti.ABLEGERINNE_WANDKONSOLE_2M);
    }
    isGuidefast() {
        var _a;
        return Boolean((_a = this.artNr) === null || _a === void 0 ? void 0 : _a.startsWith('GF'));
    }
    calculateLaengeGesamt(kette, useFestpunktmodul) {
        var _a, _b, _c;
        const verfahrweg_mm = (_a = echain_shared_quantities_1.Q.optional(kette.Verfahrweg)) === null || _a === void 0 ? void 0 : _a.mm;
        const x1_mm = (_b = echain_shared_quantities_1.Q.optional(kette.X1)) === null || _b === void 0 ? void 0 : _b.mm;
        const d1_mm = (_c = echain_shared_quantities_1.Q.optional(kette.D1)) === null || _c === void 0 ? void 0 : _c.mm;
        let laenge;
        const stuecklaenge = this.calculateStuecklange();
        if (!verfahrweg_mm || !x1_mm || !d1_mm) {
            return undefined;
        }
        if (this.isLengthCalculationPossible() && stuecklaenge) {
            let laengeAfterRounding;
            if (this.typ === echain_shared_articles_1.FuehrungsrinneTyp.SuperAlu) {
                const laengeBeforeRounding = (0, echain_math_1.calcFuehrungsrinneSuperAlu_Laengegesamt_TL_mm)(verfahrweg_mm, x1_mm, d1_mm);
                laengeAfterRounding = (0, echain_math_1.roundFuehrungsrinneSuperAlu_Laengegesamt_TL_mm)(laengeBeforeRounding, stuecklaenge.mm);
            }
            else if (this.typ === echain_shared_articles_1.FuehrungsrinneTyp.Stahl) {
                if (this.isFuehrungsrinneOhneMontageSet()) {
                    const laengeBeforeRounding = (0, echain_math_1.calcFuehrungsrinneStahlOhneFPMod_Laengegesamt_TL_mm)(verfahrweg_mm, x1_mm, d1_mm);
                    laengeAfterRounding = (0, echain_math_1.roundFuehrungsrinneStahlOhneFPMod_Laengegesamt_TL_mm)(laengeBeforeRounding, stuecklaenge.mm);
                }
                else if (useFestpunktmodul) {
                    const laengeBeforeRounding = (0, echain_math_1.calcFuehrungsrinneStahl_Laengegesamt_TL_mm)(verfahrweg_mm, x1_mm, d1_mm);
                    laengeAfterRounding = (0, echain_math_1.roundFuehrungsrinneStahl_Laengegesamt_TL_mm)(laengeBeforeRounding, stuecklaenge.mm);
                }
                else {
                    // TODO Change echain math function or provide alias EKE-6227 Provide new length calculation for Stahl Fuehrungsrinnen
                    const laengeBeforeRounding = (0, echain_math_1.calcFuehrungsrinneSuperAlu_Laengegesamt_TL_mm)(verfahrweg_mm, x1_mm, d1_mm);
                    laengeAfterRounding = (0, echain_math_1.roundFuehrungsrinneSuperAlu_Laengegesamt_TL_mm)(laengeBeforeRounding, stuecklaenge.mm);
                }
            }
            else {
                return undefined;
            }
            laenge = echain_shared_quantities_1.Length.mm(laengeAfterRounding);
        }
        return laenge;
    }
    calculateLaengeMitGleitschiene(rinnenLaengeGesamt, rinnenLaengeOhneGleitschiene, useFestpunktmodul) {
        let laenge;
        const stuecklaenge = this.calculateStuecklange();
        if (this.isLengthCalculationPossible() && stuecklaenge) {
            if (this.typ === echain_shared_articles_1.FuehrungsrinneTyp.SuperAlu) {
                laenge = echain_shared_quantities_1.Length.mm((0, echain_math_1.calcFuehrungsrinneSuperAlu_LaengeMitGLS_TG1_mm)(rinnenLaengeGesamt.mm, rinnenLaengeOhneGleitschiene.mm));
            }
            else if (this.typ === echain_shared_articles_1.FuehrungsrinneTyp.Stahl) {
                if (this.isFuehrungsrinneOhneMontageSet()) {
                    laenge = echain_shared_quantities_1.Length.mm((0, echain_math_1.calcFuehrungsrinneStahlOhneFPMod_LaengeMitGLS_TG1_mm)(rinnenLaengeGesamt.mm, rinnenLaengeOhneGleitschiene.mm));
                }
                else if (useFestpunktmodul) {
                    const festpunktmodulLaenge_mm = (0, echain_math_1.calcFuehrungsrinneStahl_LaengeFP_TFP1_mm)(stuecklaenge.mm);
                    laenge = echain_shared_quantities_1.Length.mm((0, echain_math_1.calcFuehrungsrinneStahl_LaengeMitGLS_TG1_mm)(rinnenLaengeGesamt.mm, rinnenLaengeOhneGleitschiene.mm, festpunktmodulLaenge_mm));
                }
                else {
                    // TODO Change echain math function or provide alias EKE-6227 Provide new length calculation for Stahl Fuehrungsrinnen
                    laenge = echain_shared_quantities_1.Length.mm((0, echain_math_1.calcFuehrungsrinneSuperAlu_LaengeMitGLS_TG1_mm)(rinnenLaengeGesamt.mm, rinnenLaengeOhneGleitschiene.mm));
                }
            }
        }
        return laenge;
    }
    calculateLaengeOhneGleitschiene(kette, useFestpunktmodul) {
        var _a, _b, _c;
        let laenge;
        const kettenLaenge_mm = (_a = echain_shared_quantities_1.Q.optional(kette === null || kette === void 0 ? void 0 : kette.EffektiveLaenge)) === null || _a === void 0 ? void 0 : _a.mm;
        const k2_mm = (_b = echain_shared_quantities_1.Q.optional(kette.K2)) === null || _b === void 0 ? void 0 : _b.mm;
        const d1_mm = (_c = echain_shared_quantities_1.Q.optional(kette.D1)) === null || _c === void 0 ? void 0 : _c.mm;
        if (!kettenLaenge_mm || !k2_mm || !d1_mm) {
            return undefined;
        }
        const stuecklaenge = this.calculateStuecklange();
        if (this.isLengthCalculationPossible() && stuecklaenge) {
            let laengeAfterRounding;
            if (this.typ === echain_shared_articles_1.FuehrungsrinneTyp.SuperAlu) {
                const laengeBeforeRounding = (0, echain_math_1.calcFuehrungsrinneSuperAlu_LaengeOhneGLS_TW1_mm)(kettenLaenge_mm, k2_mm, d1_mm);
                laengeAfterRounding = (0, echain_math_1.roundFuehrungsrinneSuperAlu_LaengeOhneGLS_TW1_mm)(laengeBeforeRounding, stuecklaenge.mm);
            }
            else if (this.typ === echain_shared_articles_1.FuehrungsrinneTyp.Stahl) {
                if (this.isFuehrungsrinneOhneMontageSet()) {
                    const laengeBeforeRounding = (0, echain_math_1.calcFuehrungsrinneStahlOhneFPMod_LaengeOhneGLS_TW1_mm)(kettenLaenge_mm, k2_mm, d1_mm);
                    laengeAfterRounding = (0, echain_math_1.roundFuehrungsrinneStahlOhneFPMod_LaengeOhneGLS_TW1_mm)(laengeBeforeRounding, stuecklaenge.mm);
                }
                else if (useFestpunktmodul) {
                    const laengeBeforeRounding = (0, echain_math_1.calcFuehrungsrinneStahl_LaengeOhneGLS_TW1_mm)(kettenLaenge_mm, k2_mm, d1_mm);
                    laengeAfterRounding = (0, echain_math_1.roundFuehrungsrinneStahl_LaengeOhneGLS_TW1_mm)(laengeBeforeRounding, stuecklaenge.mm);
                }
                else {
                    // TODO Change echain math function or provide alias EKE-6227 Provide new length calculation for Stahl Fuehrungsrinnen
                    const laengeBeforeRounding = (0, echain_math_1.calcFuehrungsrinneSuperAlu_LaengeOhneGLS_TW1_mm)(kettenLaenge_mm, k2_mm, d1_mm);
                    laengeAfterRounding = (0, echain_math_1.roundFuehrungsrinneSuperAlu_LaengeOhneGLS_TW1_mm)(laengeBeforeRounding, stuecklaenge.mm);
                }
            }
            else {
                return undefined;
            }
            laenge = echain_shared_quantities_1.Length.mm(laengeAfterRounding);
        }
        return laenge;
    }
    calculateAnzahlMitGleitschiene(rinnenLaengeMitGleitschiene, useFestpunktmodul) {
        let count;
        const stuecklaenge = this.calculateStuecklange();
        if (this.isLengthCalculationPossible() && stuecklaenge) {
            if (this.typ === echain_shared_articles_1.FuehrungsrinneTyp.SuperAlu) {
                count = (0, echain_math_1.calcFuehrungsrinneSuperAlu_AnzahlMitGLS_TG1Q)(rinnenLaengeMitGleitschiene.mm, stuecklaenge.mm);
            }
            else if (this.typ === echain_shared_articles_1.FuehrungsrinneTyp.Stahl) {
                if (this.isFuehrungsrinneOhneMontageSet()) {
                    count = (0, echain_math_1.calcFuehrungsrinneStahlOhneFPMod_AnzahlMitGLS_TG1Q)(rinnenLaengeMitGleitschiene.mm, stuecklaenge.mm);
                }
                else if (useFestpunktmodul) {
                    count = (0, echain_math_1.calcFuehrungsrinneStahl_AnzahlMitGLS_TG1Q)(rinnenLaengeMitGleitschiene.mm, stuecklaenge.mm);
                }
                else {
                    // TODO Change echain math function or provide alias EKE-6227 Provide new length calculation for Stahl Fuehrungsrinnen
                    count = (0, echain_math_1.calcFuehrungsrinneSuperAlu_AnzahlMitGLS_TG1Q)(rinnenLaengeMitGleitschiene.mm, stuecklaenge.mm);
                }
            }
        }
        return count;
    }
    calculateAnzahlOhneGleitschiene(rinnenLaengeOhneGleitschiene, useFestpunktmodul) {
        let count;
        const stuecklaenge = this.calculateStuecklange();
        if (this.isLengthCalculationPossible() && stuecklaenge) {
            if (this.typ === echain_shared_articles_1.FuehrungsrinneTyp.SuperAlu) {
                count = (0, echain_math_1.calcFuehrungsrinneSuperAlu_AnzahlOhneGLS_TW1Q)(rinnenLaengeOhneGleitschiene.mm, stuecklaenge.mm);
            }
            else if (this.typ === echain_shared_articles_1.FuehrungsrinneTyp.Stahl) {
                if (this.isFuehrungsrinneOhneMontageSet()) {
                    count = (0, echain_math_1.calcFuehrungsrinneStahlOhneFPMod_AnzahlOhneGLS_TW1Q)(rinnenLaengeOhneGleitschiene.mm, stuecklaenge.mm);
                }
                else if (useFestpunktmodul) {
                    const laengeFestpunktmodul_mm = (0, echain_math_1.calcFuehrungsrinneStahl_LaengeFP_TFP1_mm)(stuecklaenge.mm);
                    count = (0, echain_math_1.calcFuehrungsrinneStahl_AnzahlOhneGLS_TW1Q)(rinnenLaengeOhneGleitschiene.mm, laengeFestpunktmodul_mm, stuecklaenge.mm);
                }
                else {
                    // TODO Change echain math function or provide alias EKE-6227 Provide new length calculation for Stahl Fuehrungsrinnen
                    count = (0, echain_math_1.calcFuehrungsrinneSuperAlu_AnzahlOhneGLS_TW1Q)(rinnenLaengeOhneGleitschiene.mm, stuecklaenge.mm);
                }
            }
        }
        return count;
    }
    calculateMinBauraumBreite(zusBreiteFRBefestigung, kette) {
        let minBreite;
        const hasKetteProperties = kette instanceof Kette_1.Kette ? Boolean(kette.aussenbreite) : Boolean(kette.Aussenbreite_mm);
        if (this.isLengthCalculationPossible() && hasKetteProperties) {
            const ketteAussenbreite_mm = kette instanceof Kette_1.Kette ? kette.aussenbreite.mm : kette.Aussenbreite_mm;
            if (ketteAussenbreite_mm) {
                minBreite = this.calculateMinBauraumBreitePrimitives(zusBreiteFRBefestigung.breite.mm, ketteAussenbreite_mm);
            }
        }
        return minBreite;
    }
    calculateMinBauraumBreitePrimitives(zusBreiteFRBefestigungBreite_mm, ketteAussenbreite_mm) {
        let minBreite;
        if (this.isLengthCalculationPossible()) {
            const breite_mm = (0, echain_math_1.calcMinBauraumFuehrungsrinneBreite_mm)(zusBreiteFRBefestigungBreite_mm, ketteAussenbreite_mm);
            minBreite = echain_shared_quantities_1.Length.mm(breite_mm);
        }
        return minBreite;
    }
    calculateMinBauraumLaenge(rinnenLaengeGesamt) {
        let minLaenge;
        if (this.isLengthCalculationPossible()) {
            const laenge_mm = (0, echain_math_1.calcMinBauraumFuehrungsrinneLaenge_mm)(rinnenLaengeGesamt.mm);
            minLaenge = echain_shared_quantities_1.Length.mm(laenge_mm);
        }
        return minLaenge;
    }
    calculateMinBauraumHoehe(kette) {
        var _a, _b, _c;
        let minHoehe;
        let hasKetteProperties = false;
        if (kette instanceof Kette_1.Kette) {
            hasKetteProperties = Boolean(kette.aussenhoehe && kette.hoeheVorspannung && kette.biegeradius);
        }
        else {
            hasKetteProperties = Boolean(kette.Aussenhoehe_mm && kette.HoeheVorspannung_mm && kette.Biegeradius_mm);
        }
        if (this.isLengthCalculationPossible() && this.auflageHoehe && hasKetteProperties) {
            let ketteAussenhoehe_mm;
            let ketteHoeheVorspannung_mm;
            let ketteBiegeradius_mm;
            if (kette instanceof Kette_1.Kette) {
                ketteAussenhoehe_mm = (_a = kette.aussenhoehe) === null || _a === void 0 ? void 0 : _a.mm;
                ketteHoeheVorspannung_mm = (_b = kette.hoeheVorspannung) === null || _b === void 0 ? void 0 : _b.mm;
                ketteBiegeradius_mm = (_c = kette.biegeradius) === null || _c === void 0 ? void 0 : _c.mm;
            }
            else {
                ketteAussenhoehe_mm = kette.Aussenhoehe_mm;
                ketteHoeheVorspannung_mm = kette.HoeheVorspannung_mm;
                ketteBiegeradius_mm = kette.Biegeradius_mm;
            }
            minHoehe = this.calculateMinBauraumHoehePrimitives(ketteAussenhoehe_mm, ketteHoeheVorspannung_mm, ketteBiegeradius_mm);
        }
        return minHoehe;
    }
    calculateMinBauraumHoehePrimitives(ketteAussenhoehe_mm, ketteHoeheVorspannung_mm, ketteBiegeradius_mm) {
        if (ketteAussenhoehe_mm && ketteHoeheVorspannung_mm && ketteBiegeradius_mm) {
            let minHoehe;
            if (this.isLengthCalculationPossible() && this.auflageHoehe) {
                const hoehe_mm = (0, echain_math_1.calcMinBauraumFuehrungsrinneHoehe_mm)(this.auflageHoehe.mm, ketteAussenhoehe_mm, ketteHoeheVorspannung_mm, ketteBiegeradius_mm);
                minHoehe = echain_shared_quantities_1.Length.mm(hoehe_mm);
            }
            return minHoehe;
        }
        return undefined;
    }
    findZusBreiteFRBefestigungInnen(montageSetId) {
        return this.zusBreiteFRBefestigungInnen.find((befestigung) => {
            return befestigung.montageSetId === montageSetId;
        });
    }
    findZusBreiteFRBefestigungAussen(montageSetId) {
        return this.zusBreiteFRBefestigungAussen.find((befestigung) => {
            return befestigung.montageSetId === montageSetId;
        });
    }
    findBefestigungInnenCProfil(kettenSerieId) {
        return this.befestigungInnenCProfil.find((innenCProfil) => {
            return innenCProfil.kettenSerieId === kettenSerieId;
        });
    }
}
exports.Fuehrungsrinne = Fuehrungsrinne;
//# sourceMappingURL=fuehrungsrinne.js.map